module.exports = __webpack_public_path__ + "fonts/ralewayregular.dd127af.woff2";